import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import useSiteMetadata from "./SiteMetadata";
import { withPrefix } from "gatsby";

//@TODO the card image based on page props, if no image passed, show basic company logo one

function SEO({
  description,
  lang,
  meta,
  keywords,
  title,
  img,
  robots,
  twitterCardContent,
}) {
  const {
    companyname,
    description: companydesc,
    slogan,
    altslogan,
    subtagline,
    email,
    phonenumber,
  } = useSiteMetadata();

  const metaDescription = description || companydesc;
  const metaTags = [  ];

  if (title) {
    metaTags.push({
      property: "og:title",
      content: title,
    });
    metaTags.push({
      name: "twitter:title",
      content: title,
    });
  }

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang,
        }}
        title={title ? title : companyname}
        titleTemplate={`%s`}
      >
        {description ? <meta name="description" content={description} /> : null}
        {description ? (
          <meta name="og:description" content={description} />
        ) : null}
        {description ? (
          <meta name="twitter:description" content={description} />
        ) : null}

        {img ? <meta name="og:image" content={img} /> : null}
        {img ? <meta name="og:image:url" content={`${img}`} /> : null}
        {img ? <meta name="twitter:image" content={`${img}`} /> : null}

        {keywords ? <meta name="keywords" content={keywords} /> : null}
        
   <meta name="twitter:card" content={twitterCardContent ? twitterCardContent : " summary"} />  
      <meta name="og:type" content="business.business" />  
      

        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${withPrefix("/")}favicon/apple-touch-icon.png`}
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}favicon/favicon-48x48.png`}
          sizes="48x48"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}favicon/favicon-72x72.png`}
          sizes="72x72"
        />
         <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}favicon/favicon-128x128.png`}
          sizes="128x128"
        />
        
        
        <link
          rel="mask-icon"
          href={`${withPrefix("/")}img/safari-pinned-tab.svg`}
          color="#ff4400"
        />
        <meta name="theme-color" content="#fff" />
      </Helmet>
    </>
  );
}

SEO.defaultProps = {
  lang: "en",
  meta: [],
  keywords: [],
  robots: "index",
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  robots: PropTypes.string,
  twitterCardContent: PropTypes.string,
};

export default SEO;

// <Helmet>
// <html lang="en" />
// <title>{companyname}</title>
// <meta name="description" content={description} />

// <meta property="og:type" content="business.business" />
// <meta property="og:title" content={companyname} />
// <meta property="og:url" content="/" />
// <meta
//   property="og:image"
//   content={`${withPrefix('/')}img/og-image.jpg`}
// />
// </Helmet>
